import { AlenSchedule } from "src/interfaces/IProgram";
import { useCallback, useContext, useEffect, useState } from "react";
import { AuthContext } from "src/contexts/AuthContext";
import { AxiosError } from "axios";
import {
  ScheduleDto,
  UpdateScheduleStatusDto,
} from "src/pages/FleetManagement/pages/ViewProgram/AlenScheduling/types";
import { AlenAccessToken } from "../authService";
import { makeAlenAxios } from ".";

type FetchAlenScheduleResponse = {
  schedulers: AlenSchedule[];
};

const fetchAlenLocationSchedule = async (
  alenAccess: AlenAccessToken,
  locationId: number
) => {
  const alenAxios = makeAlenAxios(alenAccess);
  return alenAxios.get<FetchAlenScheduleResponse>(`/schedulers/${locationId}`);
};

export const createOrUpdateAlenSchedule = async (
  alenAccess: AlenAccessToken,
  schedule: ScheduleDto
) => {
  const alenAxios = makeAlenAxios(alenAccess);
  return alenAxios.post("/scheduler", schedule);
};

export const updateAlenSchedule = async (
  alenAccess: AlenAccessToken,
  schedule: UpdateScheduleStatusDto
) => {
  const alenAxios = makeAlenAxios(alenAccess);
  return alenAxios.put("/scheduler/status", schedule);
};

const useAlenSchedules = (propertyId: number) => {
  const { user } = useContext(AuthContext);
  const [data, setData] = useState<AlenSchedule[] | undefined>();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<AxiosError | undefined>();
  const fetchSchedule = useCallback(() => {
    if (user?.alen) {
      setIsLoading(true);
      fetchAlenLocationSchedule(user.alen, propertyId)
        .then((response) => {
          setData(response.data.schedulers);
        })
        .catch((err: unknown) => {
          if (err instanceof AxiosError) {
            setError(err);
          } else {
            // eslint-disable-next-line no-console
            console.error(err);
          }
        })
        .finally(() => setIsLoading(false));
    }
  }, [propertyId, user]);
  useEffect(() => {
    fetchSchedule();
  }, [fetchSchedule]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchSchedule,
  };
};

export default useAlenSchedules;
